export const subMenu = () => {
  const menuItems = document.querySelectorAll(".menu-item-has-children");

  const openSubMenu = (li) => {
    li.classList.add("submenu-open");
    li.querySelector(".sub-menu")?.classList.add("isOpened");
  };

  const closeSubMenu = (li) => {
    li.classList.remove("submenu-open");
    li.querySelector(".sub-menu")?.classList.remove("isOpened");
  };

  const closeAllExcept = (except) => {
    document
      .querySelectorAll(".menu-item-has-children.submenu-open")
      .forEach((li) => {
        if (li !== except) closeSubMenu(li);
      });
  };

  const isDesktop = () => window.innerWidth >= 1200;

  menuItems.forEach((li) => {
    const link = li.querySelector("a:first-child");
    const submenu = li.querySelector(".sub-menu");
    if (!link || !submenu) return;

    // HOVER – tylko desktop, tylko wizualnie
    li.addEventListener("mouseenter", () => {
      if (isDesktop()) {
        closeAllExcept(li);
        openSubMenu(li);
      }
    });
    li.addEventListener("mouseleave", () => {
      if (isDesktop()) closeSubMenu(li);
    });

    // CLICK – działa zawsze, logika zależna od breakpoint
    link.addEventListener("click", (e) => {
      e.preventDefault();
      if (isDesktop()) {
        // Desktop → toggle własnego submenu i zamknij inne jeśli otwieramy
        const isOpen = li.classList.contains("submenu-open");
        if (!isOpen) {
          closeAllExcept(li);
          openSubMenu(li);
        } else {
          closeSubMenu(li);
        }
      } else {
        // MOBILE → toggle tylko własnego submenu, nie ruszamy innych
        li.classList.toggle("submenu-open");
        submenu.classList.toggle("isOpened");
      }
    });
  });

  // Klik poza menu → zamyka wszystkie submenu tylko desktop
  document.addEventListener("click", (e) => {
    if (isDesktop()) {
      if (!e.target.closest(".menu-item-has-children")) closeAllExcept(null);
    }
  });
};
